import { Component, Input } from '@angular/core';

@Component({
  selector: 'notification-item-preview',
  templateUrl: 'notification-item-preview.component.html',
  styleUrls: ['notification-item-preview.component.scss'],
  providers: [],
})
export class NotificationItemPreviewComponent {
  @Input() public priority: boolean;
  @Input() public category: string;
  @Input() public scheduled: boolean;
}
